import React, { useEffect, useState } from 'react'
import { OBJECT_NET, OBJECT_OBJECT } from '../../../../store/Settings/sets'
import { cl } from '../../../../utilities/cl'
import { prepareSettings } from '../../utilities/prepareSettings'
import { carryUpdate } from '../../utilities/carryUpdate'
import { updateHelper } from '../../utilities/updateHelper'
import { setsex, setsmob } from '../../utilities/setsclasses'
import fields from './fields'
import Builder from '../../Builder'
import fieldWarntraffic from "./items/warntraffic";
import fieldBpalg from "./items/bpalg";
import fieldMsync from "./items/msync";
import ItemSave from "./items/save";
import { useDispatch } from 'react-redux'

import { updateOptions as settings_updateOptions } from '../../../../store/Settings/actions'
import { putChanged } from '../../../../store/Settings/actions/Changed'
import { Form } from 'react-bootstrap'


const SettingsObjectNet = ({
    className = "",
    settings = {},
    stateKey,
    loadSettings,
    updateOptions,
    saveSettings,
}) => {
    className = cl(className, "SettingsObjectMusic")



    // Остальной код остается без изменений
    let validMap
    [settings, validMap] = prepareSettings({
        type: OBJECT_OBJECT,
        settings: settings,
    })


    updateOptions = carryUpdate({
        type: OBJECT_OBJECT,
        stateKey,
        updateOptions
    })

    const hChange = (name, data) => updateHelper({
        name,
        updateOptions: data || updateOptions
    })



    return (
        <Builder
            className={className}
            groups={{
                all: [{
                    data: {
                        // title: "Настройки музыки",
                        columns: 1,
                        // className: setsex(["col-1"]) + setsmob(["col-1"]),
                    },
                    items: [
                        <Form.Group className="w-100">
                            <Form.Label>Алгоритм паузы (только аудиосервер)</Form.Label>
                            <Form.Check
                                checked={settings["pausealg"] === 0}
                                name="pausealg"
                                value={0}
                                type="radio"
                                id="pausealg-0"
                                label="После рекламы начинать новый трек"
                                onClick={(e) =>
                                    hChange("pausealg")({ value: Number(e.target.value) })
                                }
                            />
                            <Form.Check
                                checked={settings["pausealg"] === 1}
                                name="pausealg"
                                value={1}
                                type="radio"
                                id="pausealg-1"
                                label="Во время рекламы ставить трек на паузу"
                                onClick={(e) =>
                                    hChange("pausealg")({ value: Number(e.target.value) })
                                }
                            />
                        </Form.Group>,
                        {
                            title: "Проигрывать музыку по очереди из каждого списка",
                            components: fieldBpalg({
                                settings,
                                name: "bpalg",
                                onChange: hChange("bpalg"),
                            }),
                        },
                        {
                            title: "Синхронизировать музыку",
                            subtitle: "* Внимание, возможен большой трафик!",
                            components: fieldMsync({
                                settings,
                                name: "msync",
                                onChange: hChange("msync"),
                                additionalListener: {
                                    onChange: hChange("videorandom"),
                                    inveted: true,
                                    value: settings["videorandom"],
                                },
                            }),
                        },
                        {
                            title:
                                "Трафик в мегабайтах при превышении которого предупреждать",
                            components: fieldWarntraffic({
                                settings,
                                name: "warntraffic",
                                onChange: hChange("warntraffic"),
                            }),
                        },
                    ],
                },
                    ,

                // Save
                {
                    data: {
                        className: setsex(["col-2-nowrap"]),
                    },
                    items: [
                        <ItemSave
                            settings={settings}
                            stateKey={stateKey}
                            fields={fields}
                            saveSettings={saveSettings}
                            disabled={!validMap.validResult}
                        />,
                    ],
                },],
            }}
        />
    )
}

export default SettingsObjectNet